var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverDueLoan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5Z",
    fill: "#D43939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83464 5.99935C6.2613 5.99935 4.16797 8.09268 4.16797 10.666C4.16797 13.2393 6.2613 15.3327 8.83464 15.3327C11.408 15.3327 13.5013 13.2393 13.5013 10.666C13.5013 8.09268 11.408 5.99935 8.83464 5.99935ZM8.83464 14.3327C6.81464 14.3327 5.16797 12.686 5.16797 10.666C5.16797 8.64602 6.81464 6.99935 8.83464 6.99935C10.8546 6.99935 12.5013 8.64602 12.5013 10.666C12.5013 12.686 10.8546 14.3327 8.83464 14.3327ZM6.66797 5.16602C6.66797 4.89268 6.89464 4.66602 7.16797 4.66602H10.5013C10.7746 4.66602 11.0013 4.89268 11.0013 5.16602C11.0013 5.43935 10.7746 5.66602 10.5013 5.66602H7.16797C6.89464 5.66602 6.66797 5.43935 6.66797 5.16602ZM9.33464 8.66602V10.666C9.33464 10.9393 9.10797 11.166 8.83464 11.166C8.5613 11.166 8.33464 10.9393 8.33464 10.666V8.66602C8.33464 8.39268 8.5613 8.16602 8.83464 8.16602C9.10797 8.16602 9.33464 8.39268 9.33464 8.66602ZM13.6946 7.51268C13.5946 7.61268 13.468 7.65935 13.3413 7.65935C13.2146 7.65935 13.088 7.61268 12.988 7.51268L11.988 6.51268C11.7946 6.31935 11.7946 5.99935 11.988 5.80602C12.1813 5.61268 12.5013 5.61268 12.6946 5.80602L13.6946 6.80602C13.888 6.99935 13.888 7.31935 13.6946 7.51268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverDueLoan);
export default __webpack_public_path__ + "static/media/overDueLoan.0109d7742a8a9065c8e504dbc789d8bf.svg";
export { ForwardRef as ReactComponent };